import { HIDE_MOBILE_BANNER } from './action-constants';

const initialState = {
  // once user dismisses the mobile banner, we should not show again in that session
  hideMobileBanner: false
};

export const designFeedbackReducerKey = 'designFeedback';

export const designFeedbackReducer = (state = initialState, action) => {
  switch (action.type) {
    case HIDE_MOBILE_BANNER:
      return {
        ...state,
        hideMobileBanner: true
      };

    default:
      return state;
  }
};
